import { TabPanel as PrimeTabPanel } from 'primereact/tabview'

const TabPanel = PrimeTabPanel

export default TabPanel
